import {createContext, useContext, useReducer} from "react";
import TextSection from "../components/TextSection";
import {PriceContext, PriceDispatch} from "./PriceContext";
import searchByField from "../services/SearchProductData";
import {ConfigContext} from "./ConfigContext";
import {convertMMtoPx, convertMMtoPxWithScaling, validateAllLetters} from "../services/helpers";
import {WorkingSizeContext} from "./WorkingSizeContext";

const initData = []
export const TextSectionsListContext = createContext(null);
export const TextSectionsDispatch = createContext(null);

export const TextSectionsListProvider = ({children}) => {
    const configContext = useContext(ConfigContext);
    const priceDispatch = useContext(PriceDispatch);
    const priceContext = useContext(PriceContext);
    const workingSizeContext = useContext(WorkingSizeContext);

    const [textSections, dispatch] = useReducer(
        (state, action) => TextSectionsReducer(state, action, configContext, priceDispatch, priceContext, workingSizeContext),
        initData
    )
    return (
        <TextSectionsListContext.Provider value={textSections}>
            <TextSectionsDispatch.Provider value={dispatch}>
                {children}
            </TextSectionsDispatch.Provider>
        </TextSectionsListContext.Provider>
    )
}

function findLetterDataFromCSVFile(letter, configContext) {
    //console.log(letter)
    const AlfabetZnak = letter
    const CzcionkaId = configContext.selectedFontObject.font[0].id_erp;
    const MocowanieId = configContext.selectedMountingObject.id_erp;
    const RozmiarId = configContext.selectedFontSizeObject.id_erp;
    const MaterialId = configContext.selectedMaterialObject.id_erp;
    //jeżeli kolor nie jest srebrny to wykończenie automatycznie ustawiamy na 3 (kolor)
    const WykonczenieId = configContext.selectedColorObject.id !== 102 ? 3 : configContext.selectedMaterialObject.id_erp;
    //jeżeli kolor jest srebrny to ustawiamy null jako kolor
    const KolorId = configContext.selectedColorObject.id === 102 ? null : configContext.selectedColorObject.id_erp;

    return searchByField({
        AlfabetZnak: AlfabetZnak,
        CzcionkaId: CzcionkaId,
        MocowanieId: MocowanieId,
        RozmiarId: RozmiarId,
        MaterialId: MaterialId,
        WykonczenieId: WykonczenieId,
        KolorId: KolorId,
    });
}

function updatePrice(content, index, priceDispatch, configContext, priceContext) {
    const letters = content.split('');
    let priceNett = 0;
    let priceGross = 0;
    letters.forEach((letter) => {
        const result = findLetterDataFromCSVFile(letter, configContext);
        if (result) {
            priceNett += parseFloat(result['Cena netto PLN']);
            priceGross += parseFloat(result['Cena brutto PLN']);
        }
    });
    priceDispatch({
        type: 'updatePrice',
        payload: {
            index: index,
            priceNett: priceNett.toFixed(2),
            priceGross: priceGross.toFixed(2)
        }
    });
}

function updatePriceInAllTextSections(textSections, priceDispatch, configContext) {
    priceDispatch({
        type: 'resetPrice',
    })
    textSections.forEach((section, index) => {
        if (!section.rawContent) {
            return;
        }
        const letters = section.rawContent.split('');
        let priceNett = 0;
        let priceGross = 0;
        letters.forEach((letter) => {
            const result = findLetterDataFromCSVFile(letter, configContext);
            if (result) {
                priceNett += parseFloat(result['Cena netto PLN']);
                priceGross += parseFloat(result['Cena brutto PLN']);
            }
        });
        priceDispatch({
            type: 'updatePrice',
            payload: {
                index: index,
                priceNett: priceNett.toFixed(2),
                priceGross: priceGross.toFixed(2)
            }
        });
    });
}

function TextSectionsReducer(textSections, action, configContext, priceDispatch, priceContext, workingSizeContext) {

    switch (action.type) {
        case "set":
            return action.payload;
        case "addTextSection":
            return [
                ...textSections,
                {
                    index: textSections.length,
                    position: {
                        x: action.payload.position.x,
                        y: action.payload.position.y
                    },
                    fontSize: action.payload.fontSize,
                    fontSizeValue: action.payload.fontSizeValue,
                    fontSizeValuePx : convertMMtoPx(action.payload.fontSizeValue),
                    fontSizeValuePxWithScaling : convertMMtoPxWithScaling(action.payload.fontSizeValue, workingSizeContext.scale),
                    letterSpacing: action.payload.letterSpacing,
                    value: action.payload.value,
                    rawContent: action.payload.rawContent,
                    active: action.payload.active,
                    textAlign: action.payload.textAlign,
                    //We need to load TextSection here, otherwise saved projects will not load text sections
                    content: <TextSection
                        index={textSections.length}
                        key={textSections.length}
                        value={action.payload.value}
                        defaultFontSize={action.payload.fontSize}
                        defaultLetterSpacing={action.payload.letterSpacing}
                        defaultPosition={{
                            x: action.payload.position.x,
                            y: action.payload.position.y
                        }}
                        rawValue={action.payload.rawContent}
                    />
                }
            ];

        case "updateTextSectionActive":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        active: action.payload.active,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionPosition":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        position: action.payload.position,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionData":
            return textSections.map((section, index) => {

                if (index === action.payload.index) {
                    return {
                        ...section,
                        value: action.payload.value,
                        rawContent: action.payload.rawContent,
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionFontSize":
            updatePriceInAllTextSections(textSections, priceDispatch, configContext);
            return textSections.map((section, index) => {
                //console.log('updateTextSectionFontSize', action.payload);
                if (index === action.payload.index) {
                    return {
                        ...section,
                        fontSizeValue: action.payload.fontSizeValue,
                        fontSize: action.payload.fontSizeName,
                        fontSizeValuePx: convertMMtoPx(action.payload.fontSizeValue),
                        fontSizeValuePxWithScaling: convertMMtoPxWithScaling(action.payload.fontSizeValue, workingSizeContext.scale),
                    }
                } else {
                    return section;
                }
            });
        case "updateTextSectionLetterSpacing":
            updatePriceInAllTextSections(textSections, priceDispatch, configContext);
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        letterSpacing: action.payload.letterSpacing,
                    }
                } else {
                    return section;
                }
            });
        case "removeTextSection":
            return textSections.filter((section, index) => index !== action.payload.index);
        case "resetTextSections":
            return [];
        case "deactivateAllTextSections":
            return textSections.map((section) => {
                return {
                    ...section,
                    active: false
                }
            });
        case "removeEmptyTextSections":
            return textSections.filter((section) => section.value !== '');
        case "updateTextSectionTextAlign":
            return textSections.map((section, index) => {
                if (index === action.payload.index) {
                    return {
                        ...section,
                        textAlign: action.payload.textAlign,
                    }
                } else {
                    return section;
                }
            });
        case "recalculateTextSectionsPrice":
            updatePriceInAllTextSections(textSections, priceDispatch, configContext);
            return textSections
        default:
            throw Error('Unknown action: ' + action.type);
    }
}